// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6ff49ef6","930":"c5876e8c","975":"25d7c39d"}[chunkId] + ".chunk.js";
};